import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { CookieConsentService } from '@core/services/cookie-consent/cookie-consent.service';

@Component({
  selector: 'd2d-cookie-consent',
  standalone: true,
  imports: [CommonModule, FormsModule, DialogModule, ButtonModule, CheckboxModule],
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss'],
})
export class CookieConsentComponent implements OnInit {
  private readonly cookieService = inject(CookieConsentService);

  loading = false;
  showBanner = false;
  showPreferences = false;

  preferences = {
    essential: true,
    analytics: false,
    marketing: false,
  };

  ngOnInit(): void {
    if (!this.cookieService.hasConsent()) {
      this.showBanner = true;
    }
  }

  acceptAll(): void {
    this.saveWithApiCall({ analytics: true, marketing: true });
  }

  rejectAll(): void {
    this.saveWithApiCall({ analytics: false, marketing: false });
  }

  openPreferences(): void {
    this.showPreferences = true;
    const currentConsent = this.cookieService.getConsent();
    if (currentConsent) {
      this.preferences = {
        essential: true,
        analytics: currentConsent.categories.analytics,
        marketing: currentConsent.categories.marketing,
      };
    }
  }

  savePreferences(): void {
    this.saveWithApiCall({
      analytics: this.preferences.analytics,
      marketing: this.preferences.marketing,
    });
  }

  private saveWithApiCall(categories: { analytics: boolean; marketing: boolean }): void {
    this.loading = true;
    this.cookieService.createConsent({ consent_type: 'cookie' }).subscribe({
      next: (response) => {
        this.cookieService.saveConsentId(response.id);
        this.cookieService.saveConsent(categories);
        this.loading = false;
        this.showPreferences = false;
        this.showBanner = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }
}
